import React from "react";
import axios from "axios";
import { withRouter, Link } from "react-router-dom";
import { css } from "aphrodite";
import { validateToken, callApi } from "../../../lib/utils";
import { connect } from "react-redux";
import styles from "./style";
import { Row, Col, Modal } from "react-bootstrap";
import async from "async";
import moment from "moment";
import ActivityCard from "../ActivityCard";
import CardWidgetContentInit from "../config";
//import PatientTaskList from "./PatientTable";
import PatientTaskList from "./PatientTaskList/PatientTable";
import CustomDateRangeFilter from "../../GenericComponents/CustomDateRangeFilter";
import CategoriesCard from "../../GenericComponents/CategoriesCard";
import Footer from "../../GenericComponents/Footer";
import LiveLocationPanel from "../LiveLocationPanel";
import CustomModal from "../../GenericComponents/CustomModal";

// --- PENDING ORDER MODAL COMPONENT ---
const PendingOrderModal = ({ show, profileData, isCancelledSubs }) => {
    return (
        <Modal
            show={show}
            onHide={() => { }} // Prevents closing on background click
            backdrop="static" // Makes the background static
            keyboard={false} // Prevents closing with the Esc key
            centered
            contentClassName="border-0 shadow-lg"
        >
            <Modal.Header>
                <Modal.Title className="w-100 text-center">
                    <i className="bi bi-exclamation-triangle-fill text-warning me-2"></i>
                    Action Needed
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
                <p style={{ fontSize: "larger", fontWeight: "500" }}>Your Inspyre subscription order is still pending and needs your confirmation to be completed.</p>
                <p style={{ wordWrap: "break-word", width: "95%" }}>Please complete the required steps to activate the subscription.</p>
            </Modal.Body>
            <Modal.Footer className="border-0 d-flex justify-content-center">
                <Link
                    to={{
                        pathname: "/new/order",
                        state: {
                            referrer: "PatientDashboard",
                            userProfileData: profileData?.patientData,
                            isCancelledSubs: isCancelledSubs
                        }
                    }}
                    className="btn btn-primary"
                >
                    Complete Your Order
                </Link>
            </Modal.Footer>
        </Modal>
    );
};

class PatientDashboard extends React.Component {
    constructor(props) {
        super();
        this.state = {
            patientCards: CardWidgetContentInit.Patient,
            activityCards: CardWidgetContentInit.ActivityWidgets,
            activeCategory: -1,
            homeCardsErrorMessage: "",
            abnormalMotionEvent: {},
            patientMedication: {},
            diseases: {},
            entityClientUserMgmt: {},
            mobileAppModules: {},
            smUserMgmt: {},
            patients: {},
            isToggled: false,
            isOpen: false,
            loading: false,
            recentLocation: {},
            recentLocationLoading: true,
            geoLocationSettings: {},
            liveGPSTracking: {},
            trackingIntervalId: null,
            liveTrackingTimeoutId: null,
            acknowledgementIntervalId: null,
            trackingStatus: false,
            endingTime: 0,
            lastUpdateTime: "",
            recentSafeLocationAlertTime: "",
            recentActivities: {},
            batteryData: {},
            recentMotionMonitoring: {},
            recentHrMonitoring: {},
            recentCallForHelpMonitoring: {},
            recentFallDetectionMonitoring: null,
            maxDate: "",
            deviceConnectedForLiveTracking: false,
            liveTrackingConnectingRetryCount: 0,
            customModalMessage: "",
            customModalType: "",
            showCustomModal: false,
            oneTimeTracking: false,
            subscriptionData: {},
            showPendingOrderModal: false, // New state to control the modal
        };
        this.timer = 0;
    }

    componentDidMount() {
        this.props.setPage("dashboard", "Dashboard");
        this.props.resetFilters();
        this.props.setPaginationPages(0);
        //localStorage.removeItem("redux_localstorage_simple_appstate");
        this.fetchSafeLocation();
        this.fetchRecentGPSLocation();
        this.fetchGeoLocationSettings();
        // this.checkForOnGoingLiveTracking();
    }

    fetchData = (startDate, endDate) => {
        this.setState({ loading: true });
        async.parallel([
            () => {
                callApi("/api/patient/activity/recent", {}, "GET")
                    .then((response) => {
                        let recentActivities = response.data.data.activity;
                        let sleepActivities = response.data.data.sleepActivityDetails;
                        let currentSleepData = null;
                        let maxDate = new Date();
                        if (recentActivities?.deviceTypeId === '1') {
                            if (recentActivities.sleepSession) {
                                let secs = Math.floor(recentActivities.sleepSession / 1000);
                                let hours = Math.floor(secs / 3600);
                                let minutes = Math.floor((secs % 3600) / 60);
                                currentSleepData = [`${hours} hr ${minutes} min`];
                            }
                            if (recentActivities.endTime) maxDate = recentActivities.endTime;
                            // if (sleepActivities.length > 0) {
                            //     const datesArray = sleepActivities.map((element) => element.sleepSessions[0].endTime);
                            //     maxDate = Math.max(...datesArray);
                            // }
                        } else if (sleepActivities.length > 0) {
                            const datesArray = sleepActivities.map((element) => element.sleepSessions[0].endTime);
                            maxDate = Math.max(...datesArray);

                            currentSleepData = sleepActivities.filter((element) => {
                                return element.sleepSessions[0].endTime === maxDate;
                            }).map((val) => {
                                let secs = moment(val.sleepSessions[0].endTime).diff(moment(val.sleepSessions[0].startTime), 'seconds');
                                let hours = Math.floor(secs / (60 * 60));
                                let divisor_for_minutes = secs % (60 * 60);
                                let minutes = Math.floor(divisor_for_minutes / 60);
                                return `${hours} hr ${minutes} min`
                            })
                        }

                        let deviceStatus =
                            this.state.activityCards.deviceStatus;
                        let heartRate = this.state.activityCards.heartRate;
                        let caloriesBurned =
                            this.state.activityCards.caloriesBurned;
                        let stepsCount =
                            this.state.activityCards.stepsCount;
                        let sleep =
                            this.state.activityCards.sleep;

                        var duration =
                            recentActivities !== null
                                ? moment(new Date()).diff(
                                    recentActivities.lastUpdatedAt,
                                    "minutes"
                                )
                                : null;

                        // --- START OF CHANGED LOGIC ---

                        // Get Heart Rate Data safely
                        let heartRateData =
                            recentActivities !== null
                                ? recentActivities.avgHR
                                : null;

                        // Set heartRate value in activity widget
                        heartRate.data.value = heartRateData;

                        if (recentActivities !== null) {
                            // Condition: HR > 0 OR lastUpdatedAt <= 60 min
                            const isHeartRateActive = heartRateData !== null && heartRateData > 0;
                            const isRecent = duration !== null && duration <= 60;

                            if (isHeartRateActive && isRecent) {
                                deviceStatus.data.value = "In Use";
                                deviceStatus.countColorCodes.value = "#14A44D"; // Green
                            } else {
                                deviceStatus.data.value = "Not In Use";
                                deviceStatus.countColorCodes.value = "#DC4C64"; // Red
                            }
                        } else {
                            deviceStatus.data.value = null;
                            deviceStatus.countColorCodes.value = "#3B71CA"; // Blue/Neutral
                        }

                        stepsCount.data.value =
                            recentActivities !== null
                                ? recentActivities.stepCounts
                                : null;
                        sleep.data.value =
                            sleepActivities.length > 0
                                ? currentSleepData
                                : null;
                        caloriesBurned.data.value =
                            recentActivities !== null
                                ? recentActivities.totalCaloriesBurned
                                : null;

                        this.setState(
                            {
                                activityCards: {
                                    ...this.state.activityCards,
                                    deviceStatus,
                                    caloriesBurned,
                                    heartRate,
                                },
                                recentActivities,
                                maxDate,
                                loading: false,
                            },
                            () => {
                                this.setMonitoring(heartRateData);
                            }
                        );
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        this.setState({ loading: false }, () => {
                            this.setMonitoring(null);
                        });
                    });
            },
            () => {
                callApi("/api/patient/activity/watch-battery-status", {}, "GET")
                    .then((response) => {
                        let batteryData = response.data.data.watchBatteryStatus;
                        let battery = this.state.activityCards.battery;

                        //recentActivities.batteryPercentage = 35
                        if (batteryData !== null) {
                            if (batteryData?.batteryPercentage <= 25) {
                                battery.countColorCodes.value = "#DC4C64";
                            } else if (
                                batteryData?.batteryPercentage > 25 &&
                                batteryData?.batteryPercentage <= 75
                            ) {
                                battery.countColorCodes.value = "#E4A11B";
                            } else if (batteryData?.batteryPercentage > 75) {
                                battery.countColorCodes.value = "#14A44D";
                            }
                        } else {
                            battery.countColorCodes.value = "#3B71CA";
                        }

                        battery.data.value =
                            batteryData !== null
                                ? batteryData.batteryPercentage
                                : null;
                        this.setState({
                            activityCards: {
                                ...this.state.activityCards,
                                battery,
                            },
                            batteryData,
                            loading: false,
                        });
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        this.setState({ loading: false });
                    });
            },
            // () => {
            //     callApi(
            //         "/api/patient/dashboard/recent/monitoring",
            //         {},
            //         "GET"
            //     )
            //         .then((response) => {
            //             console.log("res monitoring...", response.data.data)
            //             let recentMotionMonitoring = response.data.data.motionMonitoringEvent;
            //             let recentHrMonitoring = response.data.data.hrMonitoringEvent;
            //             let motionMonitoring = this.state.activityCards.motionMonitoring;
            //             let heartRateMonitoring = this.state.activityCards.heartRateMonitoring;
            //             motionMonitoring.data.value = recentMotionMonitoring?.status;
            //             heartRateMonitoring.data.value = recentHrMonitoring?.status;

            //             if (motionMonitoring.data.value === "OFF") {
            //                 motionMonitoring.countColorCodes.value = "#DC4C64";
            //             } else if (motionMonitoring.data.value === "SNOOZE") {
            //                 motionMonitoring.countColorCodes.value = "#E4A11B";
            //             } else if (motionMonitoring.data.value === "ON") {
            //                 motionMonitoring.countColorCodes.value = "#14A44D";
            //             }

            //             if (heartRateMonitoring.data.value === "OFF") {
            //                 heartRateMonitoring.countColorCodes.value = "#DC4C64";
            //             } else if (heartRateMonitoring.data.value === "SNOOZE") {
            //                 heartRateMonitoring.countColorCodes.value = "#E4A11B";
            //             } else if (heartRateMonitoring.data.value === "ON") {
            //                 heartRateMonitoring.countColorCodes.value = "#14A44D";
            //             }

            //             this.setState({
            //                 activityCards: { ...this.state.activityCards, motionMonitoring, heartRateMonitoring },
            //                 loading: false,
            //             },
            //                 () => {
            //                     this.setHRColor();
            //                 });
            //         })
            //         .catch((err) => {
            //             console.log("err: ", err);
            //             this.setState({ loading: false });
            //         });
            //},
            // () => {
            //     callApi(
            //         "/api/web/patient/settings/heart-rate/monitoring",
            //         {},
            //         "GET"
            //     )
            //         .then((response) => {
            //             let hrmSettings = response.data.data.heartRateMonitoringSensorSetting;
            //             let heartRateMonitoring = this.state.activityCards.heartRateMonitoring;
            //             let heartRate = this.state.activityCards.heartRate;
            //             console.log("heart rate data...", heartRate.data.value)
            //             console.log("highHRThreshold...", hrmSettings.highHRThreshold)
            //             console.log("lowHRThreshold...", hrmSettings.lowHRThreshold)

            //             if (heartRateMonitoring.data.value === "ON" && heartRate.data.value !== null) {
            //                 if (heartRate.data.value >= hrmSettings.highHRThreshold) {
            //                     heartRate.countColorCodes.value = "#DC4C64";
            //                 } else if (heartRate.data.value <= hrmSettings.highHRThreshold && heartRate.data.value >= hrmSettings.lowHRThreshold) {
            //                     heartRate.countColorCodes.value = "#14A44D";
            //                 } else if (heartRate.data.value <= hrmSettings.lowHRThreshold) {
            //                     heartRate.countColorCodes.value = "#E4A11B";
            //                 }
            //             }

            //             this.setState({
            //                 activityCards: { ...this.state.activityCards, heartRate },
            //                 loading: false,
            //             });
            //         })
            //         .catch((err) => {
            //             console.log("err: ", err);
            //             this.setState({ loading: false });
            //         });
            // },
            () => {
                callApi(`/api/web/patient/profile`, {}, "GET")
                    .then((response) => {
                        let profileData = response.data.data;
                        this.props.setProfileData(profileData);
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                    });
            },
            () => {
                axios({
                    url: `/api/web/patient/profile/image`, //your url
                    method: "GET",
                    responseType: "blob", // important
                })
                    .then((response) => {
                        //const url = window.URL.createObjectURL(new Blob([response.data]));
                        this.getBase64(response.data).then((result) => {
                            this.props.setProfileImage(result);
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            () => {
                callApi(
                    "/api/patient/dashboard/am-event/count",
                    {
                        start: startDate,
                        end: endDate,
                        page: 1,
                        limit: 20,
                    },
                    "POST"
                )
                    .then((response) => {
                        let abnormalMotionEventCounts =
                            this.state.patientCards.abnormalMotionEventCounts;
                        //console.log("abnormalMotionEventCounts..",abnormalMotionEventCounts)
                        abnormalMotionEventCounts.counts =
                            response.data.data.abnormalMotionEventCounts;
                        this.setState({
                            patientCards: {
                                ...this.state.patientCards,
                                abnormalMotionEventCounts,
                            },
                            loading: false,
                        });
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        this.setState({ loading: false });
                    });
            },
            () => {
                callApi(
                    "/api/patient/dashboard/medication/count",
                    {
                        start: startDate,
                        end: endDate,
                        page: 1,
                        limit: 20,
                    },
                    "POST"
                )
                    .then((response) => {
                        let currentMedication =
                            this.state.activityCards.currentMedication;
                        currentMedication.data.value = response.data.data.total;
                        this.setState({
                            activityCards: {
                                ...this.state.activityCards,
                                currentMedication,
                            },
                            loading: false,
                        });
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        this.setState({ loading: false });
                    });
            },
            () => {
                callApi(
                    "/api/patient/dashboard/unplaned/mv/count",
                    {
                        start: startDate,
                        end: endDate,
                        page: 1,
                        limit: 20,
                    },
                    "POST"
                )
                    .then((response) => {
                        let unplannedMVDetails =
                            this.state.patientCards.unplannedMVDetails;

                        unplannedMVDetails.counts =
                            response.data.data.medicalVisitCounts;
                        this.setState({
                            patientCards: {
                                ...this.state.patientCards,
                                unplannedMVDetails,
                            },
                            loading: false,
                        });
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        this.setState({ loading: false });
                    });
            },
            // () => {
            //     callApi(
            //         "/api/patient/dashboard/subscription/details",
            //         {},
            //         "POST"
            //     )
            //         .then((response) => {
            //             let patientSubscriptionDetails =
            //                 this.state.patientCards.patientSubscriptionDetails;

            //             patientSubscriptionDetails.counts =
            //                 response.data.data.patientSubscriptionDetails;
            //             this.setState({
            //                 patientCards: {
            //                     ...this.state.patientCards,
            //                     patientSubscriptionDetails,
            //                 },
            //                 loading: false,
            //             });
            //         })
            //         .catch((err) => {
            //             console.log("err: ", err);
            //             this.setState({ loading: false });
            //         });
            // },
            () => {
                callApi(
                    "/api/patient/dashboard/medication/adherence",
                    {
                        start: startDate,
                        end: endDate,
                        page: 1,
                        limit: 20,
                    },
                    "POST"
                )
                    .then((response) => {
                        let medicationAdherence =
                            this.state.patientCards.medicationAdherence;

                        medicationAdherence.counts =
                            response.data.data.medicationAdherence;
                        this.setState({
                            patientCards: {
                                ...this.state.patientCards,
                                medicationAdherence,
                            },
                            loading: false,
                        });
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        this.setState({ loading: false });
                    });
            },
            () => {
                callApi(`/api/patient/appmodules`, {}, "GET")
                    .then((response) => {
                        let appModules = response.data.data.appModules;
                        let inactiveAppModules =
                            response.data.data.inactiveAppModules;

                        let totalAppModules = {};
                        let activeAppModules = {};
                        let inactiveModules = {};
                        let contactAlertLimit = null;
                        appModules.forEach((appModule) => {
                            if (appModule.short_name === "CONT") {
                                appModule.appComponents.forEach(
                                    (component) =>
                                        (contactAlertLimit = component.limit)
                                );
                            }
                            activeAppModules[appModule.short_name] =
                                appModule.appComponents.map(
                                    (component) => component.code
                                );
                            inactiveModules[appModule.short_name] =
                                appModule.inactiveAppComponents.map(
                                    (component) => component.code
                                );
                        });

                        inactiveAppModules.forEach((appModule) => {
                            inactiveModules[appModule.short_name] =
                                appModule.inactiveAppComponents.map(
                                    (component) => component.code
                                );
                        });

                        totalAppModules["active"] = activeAppModules;
                        totalAppModules["inactive"] = inactiveModules;

                        this.props.setContactAlertLimit(contactAlertLimit);
                        this.props.setAppModules(totalAppModules);
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                    });
            },
            () => {
                callApi(`/api/web/patient/settings/master`, {}, "GET")
                    .then((response) => {
                        let mobileAppSettingsMasterList =
                            response.data.data.mobileAppSettingsMasterList;
                        //console.log("mpbapp sett...", mobileAppSettingsMasterList);
                        this.props.setMobileAppSettingsMasterList(
                            mobileAppSettingsMasterList
                        );
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                    });
            },
            //   () => {
            //     callApi(`/api/web/patient/settings/abnormal-motion`, {}, "GET")
            //       .then((response) => {
            //         //let profileData = response.data.data;
            //         console.log("abnormal sett...", response);
            //         //this.props.setProfileData(profileData);
            //       })
            //       .catch((err) => {
            //         console.log("err: ", err);
            //       });
            //   },
            () => {
                callApi(`/api/admin/master/event/type`, {}, "GET")
                    .then((response) => {
                        let eventTypeList = response.data.data.eventTypeList;
                        //console.log("eventTypeList...", eventTypeList);
                        this.props.setEventTypeList(eventTypeList);
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                    });
            },
            () => {
                callApi(`/api/patient/subscription`, {}, "GET")
                    .then((response) => {
                        let subscriptionData = response.data.data;
                        let patientSubscription =
                            response.data.data.patientSubscription;
                        //console.log("subscriptionList...", response);
                        this.props.setPatientSubscription(patientSubscription);
                        this.setState({ subscriptionData });
                        if (this.props.user?.entityMaster?.shortName === "SM" && subscriptionData?.patientSubscription === null) {
                            this.setState({ showPendingOrderModal: true });
                        }
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                    });
            },
            () => {
                callApi(
                    "/api/patient/dashboard/symptoms/count",
                    {
                        start: startDate,
                        end: endDate,
                        page: 1,
                        limit: 20,
                    },
                    "POST"
                )
                    .then((response) => {
                        let symptoms = this.state.patientCards.symptoms;
                        symptoms.counts = response.data.data;
                        this.setState({
                            patientCards: {
                                ...this.state.patientCards,
                                symptoms,
                            },
                            loading: false,
                        });
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        this.setState({ loading: false });
                    });
            },
            () => {
                callApi(
                    "/api/patient/dashboard/hrm/count",
                    {
                        start: startDate,
                        end: endDate,
                        page: 1,
                        limit: 20,
                    },
                    "POST"
                )
                    .then((response) => {
                        let heartRateMonitoring =
                            this.state.patientCards.heartRateMonitoring;
                        heartRateMonitoring.counts.total =
                            response.data.data.total;
                        heartRateMonitoring.counts.lowThresholdEvents =
                            response.data.data.lte;
                        heartRateMonitoring.counts.highThresholdEvents =
                            response.data.data.hte;
                        this.setState({
                            patientCards: {
                                ...this.state.patientCards,
                                heartRateMonitoring,
                            },
                            loading: false,
                        });
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        this.setState({ loading: false });
                    });
            },
            () => {
                callApi(
                    "/api/patient/dashboard/help/count",
                    {
                        start: startDate,
                        end: endDate,
                        page: 1,
                        limit: 20,
                    },
                    "POST"
                )
                    .then((response) => {
                        let help = this.state.patientCards.help;
                        help.counts.total = response.data.data.total;
                        this.setState({
                            patientCards: { ...this.state.patientCards, help },
                            loading: false,
                        });
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        this.setState({ loading: false });
                    });
            },
            () => {
                callApi(
                    "/api/patient/dashboard/fall-event/count",
                    {
                        start: startDate,
                        end: endDate,
                        page: 1,
                        limit: 20,
                        timezone: moment.tz.guess(),
                    },
                    "POST"
                )
                    .then((response) => {
                        let fallEvents = this.state.patientCards.fallEvents;
                        fallEvents.counts.total = response.data.data.fallEventCounts.total;
                        this.setState({
                            patientCards: { ...this.state.patientCards, fallEvents },
                            loading: false,
                        });
                    })
                    .catch((err) => {
                        console.log("err: ", err);
                        this.setState({ loading: false });
                    });
            },
        ]);
    };

    setMonitoring = (hrData) => {
        callApi("/api/patient/dashboard/recent/monitoring", {}, "GET")
            .then((response) => {
                let recentMotionMonitoring =
                    response.data.data.motionMonitoringEvent;
                let recentHrMonitoring = response.data.data.hrMonitoringEvent;
                let recentCallForHelpMonitoring =
                    response.data.data.callForHelpMonitoringEvent ||
                    response.data.data.callForHelpEvent ||
                    response.data.data.calrtMonitoringEvent ||
                    response.data.data.calrtEvent ||
                    null;
                let recentFallDetectionMonitoring =
                    response.data.data.fdMonitoringEvent || null;
                let motionMonitoring =
                    this.state.activityCards.motionMonitoring;
                let heartRateMonitoring =
                    this.state.activityCards.heartRateMonitoring;
                let callForHelp = this.state.activityCards.callForHelp;
                let fallDetection = this.state.activityCards.fallDetection;
                motionMonitoring.data.value =
                    recentMotionMonitoring !== null
                        ? recentMotionMonitoring.status
                        : null;
                heartRateMonitoring.data.value =
                    recentHrMonitoring !== null
                        ? recentHrMonitoring.status
                        : null;
                callForHelp.data.value =
                    recentCallForHelpMonitoring !== null
                        ? (recentCallForHelpMonitoring.status ||
                            (recentCallForHelpMonitoring.enableCallForHelp === true ? "ON" : null) ||
                            (recentCallForHelpMonitoring.enableCallForHelp === false ? "OFF" : null))
                        : null;
                fallDetection.data.value =
                    recentFallDetectionMonitoring !== null
                        ? recentFallDetectionMonitoring.status
                        : null;

                if (motionMonitoring.data.value !== null) {
                    if (motionMonitoring.data.value === "OFF") {
                        motionMonitoring.countColorCodes.value = "#DC4C64";
                    } else if (motionMonitoring.data.value === "SNOOZE") {
                        motionMonitoring.countColorCodes.value = "#E4A11B";
                    } else if (motionMonitoring.data.value === "ON") {
                        motionMonitoring.countColorCodes.value = "#14A44D";
                    }
                } else {
                    motionMonitoring.countColorCodes.value = "#3B71CA";
                }

                if (heartRateMonitoring.data.value !== null) {
                    if (heartRateMonitoring.data.value === "OFF") {
                        heartRateMonitoring.countColorCodes.value = "#DC4C64";
                    } else if (heartRateMonitoring.data.value === "SNOOZE") {
                        heartRateMonitoring.countColorCodes.value = "#E4A11B";
                    } else if (heartRateMonitoring.data.value === "ON") {
                        heartRateMonitoring.countColorCodes.value = "#14A44D";
                    }
                } else {
                    heartRateMonitoring.countColorCodes.value = "#3B71CA";
                }

                if (callForHelp.data.value !== null) {
                    if (callForHelp.data.value === "OFF") {
                        callForHelp.countColorCodes.value = "#DC4C64";
                    } else if (callForHelp.data.value === "SNOOZE") {
                        callForHelp.countColorCodes.value = "#E4A11B";
                    } else if (callForHelp.data.value === "ON") {
                        callForHelp.countColorCodes.value = "#14A44D";
                    }
                } else {
                    callForHelp.countColorCodes.value = "#3B71CA";
                }

                this.setState(
                    {
                        activityCards: {
                            ...this.state.activityCards,
                            motionMonitoring,
                            heartRateMonitoring,
                            callForHelp,
                        },
                        recentMotionMonitoring,
                        recentHrMonitoring,
                        recentCallForHelpMonitoring,
                        // recentFallDetectionMonitoring,
                        loading: false,
                    },
                    () => {
                        this.setHRColor(hrData);
                        this.setCallForHelpStatus(recentCallForHelpMonitoring);
                        // this.setFallDetectionStatus(recentFallDetectionMonitoring);
                    }
                );
            })
            .catch((err) => {
                console.log("err: ", err);
                this.setState({ loading: false });
            });
    };

    setCallForHelpStatus = (recentCallForHelpMonitoring) => {
        if (this.state.activityCards.callForHelp.data.value !== null) return;

        callApi("/api/web/patient/settings/fetch", {}, "GET")
            .then((response) => {
                const settings = response?.data?.data?.settings || {};
                const isEnabled =
                    settings?.CALRT?.enableCallForHelp ??
                    settings?.CAlRT?.enableCallForHelp ??
                    null;
                if (isEnabled === null) return;

                let callForHelp = this.state.activityCards.callForHelp;
                callForHelp.data.value = isEnabled ? "ON" : "OFF";
                callForHelp.countColorCodes.value = isEnabled ? "#14A44D" : "#DC4C64";

                this.setState({
                    activityCards: { ...this.state.activityCards, callForHelp },
                });
            })
            .catch((err) => {
                console.log("err: ", err);
            });
    };

    // setFallDetectionStatus = (recentFallDetectionMonitoring) => {
    //     if (recentFallDetectionMonitoring) return;

    //     callApi("/api/web/patient/settings/fetch", {}, "GET")
    //         .then((response) => {
    //             const settings = response?.data?.data?.settings || {};
    //             const isEnabled = settings?.FD?.enableFallDetection ?? null;
    //             if (isEnabled === null) return;

    //             let fallDetection = this.state.activityCards.fallDetection;
    //             fallDetection.data.value = isEnabled ? "ON" : "OFF";
    //             fallDetection.countColorCodes.value = isEnabled ? "#14A44D" : "#DC4C64";

    //             this.setState({
    //                 activityCards: { ...this.state.activityCards, fallDetection },
    //             });
    //         })
    //         .catch((err) => {
    //             console.log("err: ", err);
    //         });
    // };

    setHRColor = (hrData) => {
        callApi("/api/web/patient/settings/heart-rate/monitoring", {}, "GET")
            .then((response) => {
                let hrmSettings =
                    response.data.data.heartRateMonitoringSensorSetting;
                let heartRateMonitoring =
                    this.state.activityCards.heartRateMonitoring;
                let heartRate = this.state.activityCards.heartRate;
                heartRate.data.value = hrData;

                if (
                    heartRateMonitoring.data.value === "ON" &&
                    heartRate.data.value !== null
                ) {
                    if (heartRate.data.value >= hrmSettings.highHRThreshold) {
                        heartRate.countColorCodes.value = "#DC4C64";
                    } else if (
                        heartRate.data.value <= hrmSettings.highHRThreshold &&
                        heartRate.data.value >= hrmSettings.lowHRThreshold
                    ) {
                        heartRate.countColorCodes.value = "#14A44D";
                    } else if (
                        heartRate.data.value <= hrmSettings.lowHRThreshold
                    ) {
                        heartRate.countColorCodes.value = "#E4A11B";
                    }
                }

                this.setState({
                    activityCards: { ...this.state.activityCards, heartRate },
                    loading: false,
                });
            })
            .catch((err) => {
                console.log("err: ", err);
                this.setState({ loading: false });
            });
    };

    fetchSafeLocation = () => {
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            callApi("/api/patient/geo-location/recent-alerted", {}, "GET")
                .then((response) => {
                    let recentLocation = {};
                    let recentSafeLocationAlertTime = "";
                    let safeLocation = this.state.activityCards.safeLocation;

                    if (response.status === 200) {
                        recentLocation = response.data.data.gpsLocation;
                        recentSafeLocationAlertTime = response.data.data.gpsLocation.eventTimestamp;

                        if (recentLocation.fenceAlertType === "IN_FENCE") {
                            safeLocation.data.value = "Inside";
                            safeLocation.countColorCodes.value = "#14A44D";
                        } else if (
                            recentLocation.fenceAlertType === "OUT_FENCE"
                        ) {
                            safeLocation.data.value = "Outside";
                            safeLocation.countColorCodes.value = "#DC4C64";
                        }
                    } else if (
                        response.status === 400 ||
                        response.statusCode === 400
                    ) {
                        recentSafeLocationAlertTime = "";
                    }
                    this.setState({
                        recentSafeLocationAlertTime,
                        activityCards: {
                            ...this.state.activityCards,
                            safeLocation,
                        },
                        loading: false,
                    });
                })
                .catch((err) => {
                    console.log("err: ", err);
                    let recentSafeLocationAlertTime = "";

                    this.setState({
                        loading: false,
                        recentSafeLocationAlertTime,
                    });
                });
        });
    };

    showLocationFeedback = (message, type = "") => {
        if (!message) return;
        this.setState({
            showCustomModal: true,
            customModalMessage: message,
            customModalType: type,
        });
    };

    getApiMessage = (responseOrError, fallback = "") => {
        if (!responseOrError) return fallback;
        return (
            responseOrError?.data?.message ||
            responseOrError?.data?.msg ||
            responseOrError?.message ||
            fallback
        );
    };

    fetchRecentGPSLocation = () => {
        this.setState({ recentLocationLoading: true });
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
                return;
            }
            callApi("/api/patient/geo-location/recent", {}, "GET")
                .then((response) => {
                    let recentLocation = {};
                    let lastUpdateTime = "";

                    if (response.status === 200 && response.data?.data?.gpsLocation) {
                        recentLocation = response.data.data.gpsLocation;
                        lastUpdateTime =
                            response.data.data.gpsLocation.eventTimestamp;
                    } else {
                        recentLocation = { latitude: null, longitude: null };
                        lastUpdateTime = "";
                    }
                    this.setState({
                        recentLocation,
                        lastUpdateTime,
                        recentLocationLoading: false,
                        loading: false,
                    });
                })
                .catch((err) => {
                    console.log("err: ", err);
                    this.setState({
                        loading: false,
                        recentLocationLoading: false,
                        recentLocation: { latitude: null, longitude: null },
                        lastUpdateTime: "",
                    });
                });
        });
    };

    fetchRecentLiveGPSLocation = () => {
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            let liveGPSTrackingId = this.state.liveGPSTracking.id;
            callApi(
                "/api/patient/geo-location/live-tracking/recent",
                { liveGPSTrackingId },
                "POST"
            )
                .then((response) => {
                    let recentLocation = {};
                    let lastUpdateTime = "";
                    let safeLocation = this.state.activityCards.safeLocation;

                    if (response.status === 200) {
                        recentLocation = response.data.data.gpsLocation;
                        lastUpdateTime = response.data.data.gpsLocation.eventTimestamp;

                        if (recentLocation.fenceAlertType === "IN_FENCE") {
                            safeLocation.data.value = "Inside";
                            safeLocation.countColorCodes.value = "#14A44D";
                        } else if (
                            recentLocation.fenceAlertType === "OUT_FENCE"
                        ) {
                            safeLocation.data.value = "Outside";
                            safeLocation.countColorCodes.value = "#DC4C64";
                        }
                    } else if (
                        response.status === 400 ||
                        response.statusCode === 400
                    ) {
                        recentLocation.latitude = null;
                        recentLocation.longitude = null;
                        lastUpdateTime = "";
                    }
                    this.setState({
                        recentLocation,
                        lastUpdateTime,
                        activityCards: {
                            ...this.state.activityCards,
                            safeLocation,
                        },
                        loading: false,
                    });
                })
                .catch((err) => {
                    console.log("err: ", err);
                    this.setState({ loading: false });
                });
        });
    };

    fetchGeoLocationSettings = () => {
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            callApi("/api/patient/geo-location/settings", {}, "GET")
                .then((response) => {
                    let geoLocationSettings = {};
                    let endingTime = 0;
                    if (response.status === 200) {
                        endingTime = Math.floor(
                            response.data.data.geoLocationSetting
                                .liveLocationTrackingDuration / 60
                        );
                        geoLocationSettings =
                            response.data.data.geoLocationSetting;
                    } else if (
                        response.status === 400 ||
                        response.statusCode === 400
                    ) {
                        geoLocationSettings = {
                            enableLocationAccess: true,
                            locationTrackingInterval: 300,
                            liveLocationTrackingDuration: 300,
                        };
                        endingTime = 10;
                    }

                    this.setState(
                        {
                            geoLocationSettings,
                            endingTime,
                        },
                        () => {
                            this.props.setGeoLocationSettings(
                                geoLocationSettings
                            );
                        }
                    );
                })
                .catch((err) => {
                    console.log("err: ", err);
                    let geoLocationSettings = {};
                    let endingTime = 10;
                    geoLocationSettings = {
                        enableLocationAccess: true,
                        locationTrackingInterval: 300,
                        liveLocationTrackingDuration: 300,
                    };
                    this.setState({
                        loading: false, geoLocationSettings,
                        endingTime,
                    },
                        () => {
                            this.props.setGeoLocationSettings(
                                geoLocationSettings
                            );
                        }
                    );
                });
        });
    };

    fetchCurrentLocation = () => {
        this.setState(
            {
                oneTimeTracking: true,
            },
            () => {
                this.initiateLiveTracking();
            },
        );
    };

    fetchOneTimeLiveGPSLocation = (liveTrackingId) => {
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
                return;
            }
            callApi(
                "/api/patient/geo-location/live-tracking/recent",
                { liveGPSTrackingId: liveTrackingId },
                "POST",
            )
                .then((response) => {
                    const loc = response?.data?.data?.gpsLocation;
                    if (response.status === 200 && loc) {
                        let safeLocation = this.state.activityCards.safeLocation;
                        if (loc.fenceAlertType === "IN_FENCE") {
                            safeLocation.data.value = "Inside";
                            safeLocation.countColorCodes.value = "#14A44D";
                        } else if (loc.fenceAlertType === "OUT_FENCE") {
                            safeLocation.data.value = "Outside";
                            safeLocation.countColorCodes.value = "#DC4C64";
                        }
                        this.setState(
                            {
                                recentLocation: loc,
                                lastUpdateTime: loc.eventTimestamp,
                                activityCards: {
                                    ...this.state.activityCards,
                                    safeLocation,
                                },
                            },
                            () => {
                                this.showLocationFeedback(
                                    this.getApiMessage(
                                        response,
                                        "Current location updated successfully.",
                                    ),
                                );
                                this.stopLiveTracking({ skipFeedback: true });
                            },
                        );
                    } else {
                        this.showLocationFeedback(
                            this.getApiMessage(
                                response,
                                "Unable to fetch current location. Please try again.",
                            ),
                            "error",
                        );
                        this.stopLiveTracking({ skipFeedback: true });
                    }
                })
                .catch((err) => {
                    console.log("err: ", err);
                    this.showLocationFeedback(
                        this.getApiMessage(
                            err,
                            "Unable to fetch current location. Please try again.",
                        ),
                        "error",
                    );
                    this.stopLiveTracking({ skipFeedback: true });
                });
        });
    };

    checkForOnGoingLiveTracking = () => {
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            callApi("/api/patient/geo-location/live-tracking/active", {}, "GET")
                .then((response) => {
                    let res = response.data.data;
                    let liveGPSTracking = res.liveGPSTracking;
                    if (liveGPSTracking) {
                        this.checkToStartTrackingOrWaitForAcknowledgment(
                            liveGPSTracking
                        );
                    }
                })
                .catch((err) => {
                    console.log("err: ", err);
                });
        });
    };

    getBase64 = (file) => {
        return new Promise((resolve) => {
            let baseURL = "";
            // Make new FileReader
            let reader = new FileReader();

            // Convert the file to base64 text
            reader.readAsDataURL(file);

            // on reader load somthing...
            reader.onload = () => {
                // Make a fileInfo Object
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    };

    handelToggle = () => {
        const { isToggled } = this.state;
        this.setState({ isToggled: !isToggled });
    };

    toggle = () => {
        const { isOpen } = this.state;
        this.setState({ isOpen: !isOpen });
    };

    setActiveCategory = (activeCategory, cardType) => {
        //console.log("Selected Card Type: " + cardType);
        this.setState({
            activeCategory,
        });
    };

    handleDateRange = (range) => {
        let startDate = moment(range.startDate).startOf("day").valueOf();
        let endDate = moment(range.endDate).endOf("day").valueOf();
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            this.props.setStartDate(startDate);
            this.props.setEndDate(endDate);
            this.props.setInterval(range.label);
            this.fetchData(startDate, endDate);
        });
    };

    checkActiveModule = (card) => {
        switch (card) {
            case "abnormalMotionEventCounts":
                return this.props.appModules.active?.SD ? true : false;
            case "unplannedMVDetails":
                return this.props.appModules.active?.MV ? true : false;
            case "patientMedicationCount":
                return this.props.appModules.active?.MEDC?.includes(
                    "MEDICATION_CABINET"
                )
                    ? true
                    : false;
            case "medicationAdherence":
                return this.props.appModules.active?.MEDC?.includes(
                    "MEDICATION_REMINDERS"
                )
                    ? true
                    : false;
            case "allergies":
                return this.props.appModules.active?.ALGY ? true : false;
            case "symptoms":
                return this.props.appModules.active?.SL ? true : false;
            case "heartRateMonitoring":
                return this.props.appModules.active?.HRM ? true : false;
            case "fallEvents":
                return this.props.appModules.active?.FD ? true : false;
            case "help":
                return this.props.appModules.active?.CALRT ? true : false;
            default:
                return true;
        }
    };

    setCircle = (ref) => {
        // console.log("ref...", ref)
        // this.setState({
        //   bounds: ref
        // })
    };

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor((secs % (60 * 60)) / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            h: hours,
            m: minutes,
            s: seconds,
        };
        return obj;
    }

    countDown() {
        const endingTime = Math.max(0, this.state.endingTime - 1);
        if (endingTime === 0 && this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        this.setState({ endingTime });
    }

    initiateLiveTracking = () => {
        const isOneTime = this.state.oneTimeTracking;
        this.setState({ trackingStatus: !isOneTime });
        let params = {
            trackingDuration:
                this.state.geoLocationSettings?.liveLocationTrackingDuration,
            locationTrackingInterval: 5,
        };
        if (isOneTime) {
            params.liveTrackingMode = "ONE_TIME";
        }

        validateToken((err) => {
            if (err) {
                window.location = "/logout";
                return;
            }
            callApi(
                "/api/patient/geo-location/live-tracking/start",
                params,
                "POST",
            )
                .then((response) => {
                    let liveGPSTracking = response.data.data.liveGPSTracking;
                    this.checkToStartTrackingOrWaitForAcknowledgment(
                        liveGPSTracking,
                    );
                })
                .catch((err) => {
                    console.log("err: ", err);
                    this.setState({
                        trackingStatus: false,
                        oneTimeTracking: false,
                        deviceConnectedForLiveTracking: false,
                    });
                    this.showLocationFeedback(
                        this.getApiMessage(
                            err,
                            isOneTime
                                ? "Unable to fetch current location. Please try again."
                                : "Unable to start live tracking. Please try again.",
                        ),
                        "error",
                    );
                });
        });
    };

    checkToStartTrackingOrWaitForAcknowledgment = (liveGPSTracking) => {
        if (liveGPSTracking.hasAcknowledged && !this.state.oneTimeTracking) {
            clearInterval(this.state.acknowledgementIntervalId);
            this.setState({ liveGPSTracking }, () => {
                this.startLiveTracking(liveGPSTracking, true);
            });
            return;
        }

        this.setState(
            {
                liveGPSTracking: liveGPSTracking,
                liveTrackingConnectingRetryCount: 0,
            },
            () => {
                let acknowledgementIntervalId = setInterval(() => {
                    this.checkLiveTrackingAcknowleged(liveGPSTracking);
                }, 5000);
                this.setState({
                    acknowledgementIntervalId,
                });
            },
        );
    };

    checkLiveTrackingAcknowleged = (liveGPSTracking) => {
        if (this.state.liveTrackingConnectingRetryCount > 5) {
            clearInterval(this.state.acknowledgementIntervalId);
            const isOneTime = this.state.oneTimeTracking;
            this.setState({
                acknowledgementIntervalId: null,
            });
            this.showLocationFeedback(
                isOneTime
                    ? "Unable to fetch current location. Device did not respond."
                    : "Unable to start live tracking. Device did not respond.",
                "error",
            );
            this.stopLiveTracking({ skipFeedback: true });
            return;
        }
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
                return;
            }
            callApi(
                "/api/patient/geo-location/live-tracking/ack-verify",
                { liveTrackingId: liveGPSTracking.id },
                "POST",
            )
                .then(() => {
                    clearInterval(this.state.acknowledgementIntervalId);
                    if (!this.state.oneTimeTracking) {
                        this.startLiveTracking(liveGPSTracking);
                    } else {
                        this.fetchOneTimeLiveGPSLocation(liveGPSTracking.id);
                    }
                })
                .catch(() => {
                    let liveTrackingConnectingRetryCount =
                        this.state.liveTrackingConnectingRetryCount + 1;
                    this.setState({
                        deviceConnectedForLiveTracking: false,
                        liveTrackingConnectingRetryCount,
                    });
                });
        });
    };

    startLiveTracking = (
        liveGPSTracking,
        calculateTrackingDuration = false,
    ) => {
        const totalDurationMs =
            Math.max(0, Number(liveGPSTracking.trackingDuration) || 0) * 1000;
        const acknowledgedAt = moment(liveGPSTracking.acknowledgedAt);
        const elapsedDurationMs =
            calculateTrackingDuration && acknowledgedAt.isValid()
                ? Math.max(0, moment().diff(acknowledgedAt))
                : 0;
        const remainingDurationMs = Math.max(
            0,
            totalDurationMs - elapsedDurationMs,
        );

        if (remainingDurationMs === 0) {
            this.setState({ endingTime: 0 }, () => {
                this.stopLiveTracking({ skipFeedback: true });
            });
            return;
        }

        if (this.timer) clearInterval(this.timer);
        let intervalId = setInterval(() => {
            this.fetchRecentLiveGPSLocation();
        }, 7000);
        this.timer = setInterval(() => {
            this.countDown();
        }, 60000);

        this.setState(
            {
                trackingStatus: true,
                deviceConnectedForLiveTracking: true,
                trackingIntervalId: intervalId,
                endingTime: Math.ceil(remainingDurationMs / 60000),
            },
            () => {
                let liveTrackingTimeoutId = setTimeout(() => {
                    this.stopLiveTracking();
                    if (this.state.trackingIntervalId)
                        clearInterval(this.state.trackingIntervalId);
                }, remainingDurationMs);

                this.setState({ liveTrackingTimeoutId });
            },
        );
    };

    stopLiveTracking = ({ skipFeedback = false } = {}) => {
        this.setState({ trackingStatus: false, oneTimeTracking: false });
        let params = {
            liveTrackingId: this.state.liveGPSTracking?.id,
        };
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
                return;
            }
            if (!params.liveTrackingId) {
                this.clearIntervalAndTimeout();
                return;
            }
            callApi(
                "/api/patient/geo-location/live-tracking/stop",
                params,
                "POST",
            )
                .then((response) => {
                    this.clearIntervalAndTimeout();
                    if (!skipFeedback) {
                        this.showLocationFeedback(
                            this.getApiMessage(
                                response,
                                "Live tracking stopped successfully.",
                            ),
                        );
                    }
                })
                .catch((err) => {
                    console.log("err: ", err);
                    this.clearIntervalAndTimeout();
                    if (!skipFeedback) {
                        this.showLocationFeedback(
                            this.getApiMessage(
                                err,
                                "Unable to stop live tracking. Please try again.",
                            ),
                            "error",
                        );
                    }
                });
        });
    };

    componentWillUnmount() {
        this.clearIntervalAndTimeout();
    }

    clearIntervalAndTimeout = () => {
        if (this.state.trackingIntervalId) {
            clearInterval(this.state.trackingIntervalId);
        }
        if (this.state.liveTrackingTimeoutId)
            clearTimeout(this.state.liveTrackingTimeoutId);
        if (this.state.acknowledgementIntervalId)
            clearInterval(this.state.acknowledgementIntervalId);
        if (this.timer) clearInterval(this.timer);
        this.setState({
            liveGPSTracking: null,
            trackingIntervalId: null,
            liveTrackingTimeoutId: null,
            acknowledgementIntervalId: null,
            liveTrackingConnectingRetryCount: 0,
            deviceConnectedForLiveTracking: false,
        });
    };

    updateGeoLocationSettings = () => {
        let params = {
            enableLocationAccess: true,
            locationTrackingInterval:
                this.state.geoLocationSettings.locationTrackingInterval,
            liveLocationTrackingDuration:
                this.state.geoLocationSettings.liveLocationTrackingDuration,
        };
        this.setState({ loading: true });
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            callApi("/api/patient/geo-location/settings", params, "PUT")
                .then((response) => {
                    let geoLocationSettings = {};
                    geoLocationSettings = response.data.data.geoLocationSetting;
                    this.setState(
                        { loading: false, geoLocationSettings },
                        () => {
                            this.props.setGeoLocationSettings(
                                geoLocationSettings
                            );
                        }
                    );
                })
                .catch((err) => {
                    console.log("err: ", err);
                    this.setState({ loading: false });
                });
        });
    };

    handleCustomModal = () => {
        this.setState({
            showCustomModal: false,
            customModalMessage: "",
            customModalType: "",
        });
    };

    render() {
        const { profileData } = this.props;
        const isModalVisible = this.state.showPendingOrderModal;
        const isReadOnly = this.props.user?.roleId === 10;
        return (
            <div>
                <style>{`
                    .dashboard-wrapper--blurred {
                        filter: blur(5px) brightness(0.4);
                        transition: filter 0.2s ease-in-out;
                        pointer-events: none; /* Prevents interaction with blurred content */
                    }
                `}</style>
                {/* <div><a href="/patient/profile">{"Click to goto patient profile"}</a></div>
                <div><a href="/settings/abnormal">{"Click to goto settings"}</a></div> */}

                <PendingOrderModal
                    show={isModalVisible}
                    profileData={profileData}
                    isCancelledSubs={this.state.subscriptionData?.patientSubscription?.status === 4}
                />
                {/* {Object.keys(this.state.subscriptionData).length > 0 &&
                    this.props.user?.entityMaster?.shortName === "SM" && this.state.subscriptionData?.patientSubscription === null && (
                        <div className={css(styles.activationBanner)}>
                            Your order is currently pending and requires your attention to be finalized. Please
                            <Link
                                to={{
                                    pathname: "/new/order",
                                    state: {
                                        // You can pass any data you want here
                                        referrer: "PatientDashboard",
                                        userProfileData: profileData.patientData
                                    }
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <span>{" click here "}</span>
                            </Link>
                            to complete the process.
                        </div>
                    )} */}
                <CustomModal
                    header={""}
                    name={""}
                    size={"sm"}
                    title={this.state.customModalMessage}
                    show={this.state.showCustomModal}
                    confirmButtons={false}
                    type={this.state.customModalType}
                    action={this.handleCustomModal}
                />
                <div className={isModalVisible ? "dashboard-page dashboard-wrapper--blurred" : "dashboard-page"}>
                    {isReadOnly ? <div className={css(styles.activationBanner)}>
                        {`Welcome, ${this.props.user?.caregiver?.firstName || ""} ${this.props.user?.caregiver?.lastName || ""} . You are signed in as a caregiver for ${this.props.user?.caregiverPatients?.[0]?.firstName || ""} ${this.props.user?.caregiverPatients?.[0]?.lastName || ""}, with view-only access.`}
                    </div> :
                        Object.keys(this.state.subscriptionData).length > 0 &&
                        // this.props.user?.entityMaster?.shortName === "SM" && (this.state.subscriptionData?.patientSubscription !== null && this.state.subscriptionData?.patientSubscription.status !== 4) && profileData.activationDate === null && (
                        //     <div className={css(styles.activationBanner)}>
                        //         Welcome to the Inspyre, powered by Acuma Health, portal. To start using, please activate the Acuma Health app on your phone using the credentials in your Order Confirmation email.
                        //     </div>

                        this.props.user?.entityMaster?.shortName === "SM" && (
                            <>
                                {/* Active but not yet activated */}
                                {this.state.subscriptionData?.patientSubscription !== null &&
                                    this.state.subscriptionData?.patientSubscription.status !== 4 &&
                                    profileData?.activationDate === null && (
                                        <div className={css(styles.activationBanner)}>
                                            Welcome to the Inspyre, powered by Acuma Health, portal.
                                            To start using, please activate the Acuma Health app on your phone
                                            using the credentials in your Order Confirmation email.
                                        </div>
                                    )}

                                {/* Subscription canceled (status === 4) */}
                                {this.state.subscriptionData?.patientSubscription !== null &&
                                    this.state.subscriptionData?.patientSubscription.status === 4 && (
                                        <div className={css(styles.activationBanner)}>
                                            {/* Your Acuma Health subscription has been canceled.
                                            If you wish to continue using the Inspyre portal and Acuma Health app,
                                            please reactivate your subscription or contact our support team for assistance. */}

                                            Your subscription is no longer active. To continue using the Acuma Health app, please renew your subscription by contacting our support team at support@smart-monitor.com
                                        </div>
                                    )}
                            </>
                        )}

                    <div className={css(styles.bgColor)}>
                        <Row className="mb-4 gy-4">
                            <Col
                                xs={12}
                                lg={7}
                                className="mb-4 mb-lg-0"
                                style={{
                                    borderRadius: "8px",
                                    padding: "10px",
                                    backgroundColor: "rgb(255, 255, 255)",
                                    color: "rgba(0, 0, 0, 0.87)",
                                    transition:
                                        "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                                    boxShadow:
                                        "rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 0px 5px 5px",
                                    display: "flex",
                                    flexDirection: "column",
                                    minWidth: 0,
                                    overflow: "hidden",
                                }}
                            >
                                <LiveLocationPanel
                                            zoom={15}
                                            height={"100%"}
                                            locationLoading={
                                                this.state.recentLocationLoading
                                            }
                                            center={
                                                !this.state.recentLocationLoading &&
                                                this.state.recentLocation.latitude !==
                                                    null &&
                                                    this.state.recentLocation.longitude !==
                                                    null &&
                                                    this.props.appModules?.active?.GPS?.includes(
                                                        "GEO_LOCATION_TRACKING"
                                                    ) &&
                                                    (this.state.activityCards.battery.data
                                                        .value === null ||
                                                        this.state.activityCards.battery
                                                            .data.value > 5)
                                                    ? {
                                                        lat: this.state.recentLocation
                                                            ?.latitude,
                                                        lng: this.state.recentLocation
                                                            ?.longitude,
                                                    }
                                                    : null
                                            }
                                            radius={
                                                this.state.recentLocation
                                                    ?.locationAccuracy
                                            }
                                            setCircle={(payload) => {
                                                this.setCircle(payload);
                                            }}
                                            fetchCurrentLocation={this.fetchCurrentLocation}
                                            startTracking={this.initiateLiveTracking}
                                            stopTracking={this.stopLiveTracking}
                                            trackingStatus={this.state.trackingStatus}
                                            oneTimeTracking={this.state.oneTimeTracking}
                                            endingTime={this.state.endingTime}
                                            lastUpdateTime={this.state.lastUpdateTime}
                                            enableLocationAccess={
                                                this.state.geoLocationSettings
                                                    ?.enableLocationAccess
                                            }
                                            updateGeoLocationSettings={
                                                this.updateGeoLocationSettings
                                            }
                                            appModules={this.props.appModules}
                                            deviceConnectedForLiveTracking={
                                                this.state
                                                    .deviceConnectedForLiveTracking
                                            }
                                            batteryPer={
                                                this.state.activityCards.battery
                                            }
                                            isReadOnly={isReadOnly}
                                        />
                            </Col>
                            <Col xs={12} lg={5} style={{ minWidth: 0 }}>
                                <Row className="">
                                    {/* <div
                                    className="mb-3"
                                    style={{
                                        padding: "0px 20px 8px",
                                        borderBottom: "1px solid lightgrey",
                                        fontSize: "14px",
                                        color: "grey",
                                    }}
                                >{`Last updated at :  
                                ${
                                    this.state.recentActivities !== null
                                        ? moment(
                                              this.state.recentActivities
                                                  .lastUpdatedAt
                                          ).format("MM/DD/YYYY hh:mm A")
                                        : "-"
                                }`}</div> */}
                                    {Object.keys(this.state.activityCards).map(
                                        (card) => {
                                            return (
                                                <ActivityCard
                                                    recentActivities={this.state.recentActivities}
                                                    batteryData={this.state.batteryData}
                                                    recentMotionMonitoring={this.state.recentMotionMonitoring}
                                                    recentHrMonitoring={this.state.recentHrMonitoring}
                                                    recentFallDetectionMonitoring={this.state.recentFallDetectionMonitoring}
                                                    maxDate={this.state.maxDate}
                                                    cardData={
                                                        this.state
                                                            .activityCards[card]
                                                    }
                                                    key={card}
                                                    appModules={
                                                        this.props.appModules
                                                    }
                                                    //active={this.props.appModules.active?.WM ? true : false}
                                                    loading={this.state.loading}
                                                    recentSafeLocationAlertTime={this.state.recentSafeLocationAlertTime}
                                                />
                                            );
                                        }
                                    )}
                                </Row>
                            </Col>
                        </Row>
                        <div
                            className={css(styles.dateFilterWrapper)}
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                flexWrap: "wrap",
                                zIndex: 1,
                                position: "relative",
                                //padding: "0 16px 0 0",
                            }}
                        >
                            <CustomDateRangeFilter
                                onChange={this.handleDateRange}
                                isByInterval={false}
                            />
                        </div>
                        <Row className={css(styles.categoriesRow)}>
                            {Object.keys(this.state.patientCards).map(
                                (card, index) => {
                                    if (this.checkActiveModule(card)) {
                                        return (
                                            <CategoriesCard
                                                setActiveInactive={
                                                    this.setActiveCategory
                                                }
                                                item={this.state.patientCards[card]}
                                                active={
                                                    index ===
                                                    this.state.activeCategory
                                                }
                                                //homeCardError={this.state.homeCardsErrorMessage}
                                                cardIndex={index}
                                                key={card}
                                                loading={this.state.loading}
                                            />
                                        );
                                    } else {
                                        return <></>;
                                    }
                                }
                            )}
                        </Row>
                        <PatientTaskList />
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}
export default connect(
    (store) => {
        return {
            //token: store.appstate.jwtToken,
            //menuExpanded: store.appstate.menuExpanded,
            user: store.user,
            appModules: store.dashboard.appModules,
            profileData: store.dashboard.profileData,
        };
    },
    (dispatch) => {
        return {
            setProfileData: (profileData) => {
                dispatch({
                    type: "SET_PATIENT_PROFILE_DATA",
                    payload: { profileData },
                });
            },
            setPage: (pageType, pageTitle) => {
                dispatch({
                    type: "SET_ENTITIY_PAGE_TYPE",
                    payload: { pageType },
                });
                dispatch({
                    type: "SET_PAGE_TITLE",
                    payload: { pageTitle },
                });
            },
            setProfileImage: (profileImage) => {
                dispatch({
                    type: "SET_PATIENT_PROFILE_IMAGE",
                    payload: { profileImage },
                });
            },
            setMobileAppSettingsMasterList: (mobileAppSettingsMasterList) => {
                dispatch({
                    type: "SET_MOBILE_APP_SETTINGS_MASTER_LIST",
                    payload: { mobileAppSettingsMasterList },
                });
            },
            setAppModules: (appModules) => {
                dispatch({
                    type: "SET_APP_MODULES",
                    payload: { appModules },
                });
            },
            setContactAlertLimit: (contactAlertLimit) => {
                dispatch({
                    type: "SET_CONTACT_ALERT_LIMIT",
                    payload: { contactAlertLimit },
                });
            },
            setEventTypeList: (eventTypeList) => {
                dispatch({
                    type: "SET_EVENT_TYPES",
                    payload: { eventTypeList },
                });
            },
            setPatientSubscription: (patientSubscription) => {
                dispatch({
                    type: "SET_PATIENT_SUBSCRIPTION",
                    payload: { patientSubscription },
                });
            },
            setPaginationPages: (pages) => {
                dispatch({
                    type: "SET_PAGINATION_PAGES",
                    payload: { pages },
                });
            },
            setStartDate: (startDate) => {
                dispatch({
                    type: "SET_START_DATE",
                    payload: { startDate },
                });
            },
            setEndDate: (endDate) => {
                dispatch({
                    type: "SET_END_DATE",
                    payload: { endDate },
                });
            },
            setInterval: (interval) => {
                dispatch({
                    type: "SET_INTERVAL",
                    payload: { interval },
                });
            },
            setGeoLocationSettings: (geoLocationSettings) => {
                dispatch({
                    type: "SET_GEO_LOCATION_SETTINGS",
                    payload: { geoLocationSettings },
                });
            },
            resetFilters: () => {
                dispatch({
                    type: "RESET_FILTERS",
                });
            },
        };
    }
)(withRouter(PatientDashboard));
